import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    zIndex: 999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingLeft: 20,
    paddingBottom: 20,
    paddingRight: 18,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  infoContainer: {
    flex: 1,
    paddingRight: 18,
  },
  displayName: {
    color: "white",
    fontWeight: "bold",
    fontSize: 16,
  },
  description: {
    marginTop: 10,
    color: "white",
    flexShrink: 1,
  },
  avatar: {
    height: 50,
    width: 50,
    borderRadius: 25,
    borderWidth: 2,
    borderColor: "white",
    marginBottom: 30,
  },
  defaultAvatar: {
    marginBottom: 30,
    borderRadius: 25,
    borderWidth: 2,
    borderColor: "white",
  },
  leftContainer: {
    alignItems: "center",
    marginLeft: 12,
    width: 64,
  },
  actionButton: {
    paddingBottom: 12,
    alignItems: "center",
  },
  actionButtonText: {
    color: "white",
    textAlign: "center",
    marginTop: 4,
    fontSize: 12,
    minWidth: 42,
  },
  actionButtonTextActive: {
    color: "#bff7e6",
    fontWeight: "700",
  },
  backgroundLoadIndicator: {
    alignItems: "center",
    paddingBottom: 12,
  },
  backgroundLoadCircle: {
    width: 44,
    height: 44,
    borderRadius: 22,
    borderWidth: 4,
    borderColor: "white",
    backgroundColor: "rgba(0,0,0,0.42)",
    alignItems: "center",
    justifyContent: "center",
  },
  backgroundLoadPercent: {
    color: "white",
    fontSize: 11,
    fontWeight: "700",
  },
  backgroundLoadLabel: {
    color: "white",
    fontSize: 10,
    marginTop: 3,
  },
  variantPanel: {
    position: "absolute",
    right: 88,
    bottom: 92,
    width: 310,
    maxHeight: 460,
    borderRadius: 14,
    padding: 10,
    backgroundColor: "rgba(18,18,18,0.96)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.16)",
  },
  variantPanelHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 8,
    paddingVertical: 7,
  },
  variantPanelTitle: {
    color: "white",
    fontSize: 16,
    fontWeight: "700",
  },
  variantOptions: {
    maxHeight: 390,
  },
  variantOption: {
    minHeight: 48,
    borderRadius: 9,
    paddingHorizontal: 10,
    paddingVertical: 7,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  variantOptionActive: {
    backgroundColor: "rgba(40,201,154,0.18)",
  },
  variantOptionCopy: {
    flex: 1,
    paddingRight: 8,
  },
  variantOptionText: {
    color: "white",
    fontSize: 13,
  },
  variantOptionMeta: {
    color: "#aaa",
    fontSize: 11,
    marginTop: 3,
  },
  variantEmpty: {
    color: "#aaa",
    padding: 12,
    textAlign: "center",
  },
  progressHitArea: {
    position: "absolute",
    left: 12,
    right: 12,
    top: 62,
    height: 24,
    justifyContent: "center",
  },
  progressTrack: {
    height: 6,
    borderRadius: 3,
    backgroundColor: "rgba(255,255,255,0.22)",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    borderRadius: 3,
    backgroundColor: "#28c99a",
  },
  progressThumb: {
    position: "absolute",
    top: -5,
    width: 16,
    height: 16,
    marginLeft: -8,
    borderRadius: 8,
    backgroundColor: "#ffffff",
  },
});

export default styles;
